import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import {
  notificationReadRoute,
  notificationsKey,
} from '@features/notifications';
import axiosInstance from '@server/axiosInstance';

type UseCreateApplicationNoteProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useCreateApplicationNote = ({
  setErrorText = () => { },
}: UseCreateApplicationNoteProps) => {
  const client = useQueryClient();

  const { mutate: readNotification, isLoading: isReadNotificationLoading } =
    useMutation({
      mutationFn: (variables: { notification_id: number | string, user_id?: number }) =>
        axiosInstance
          .post(notificationReadRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          client.invalidateQueries([notificationsKey]);
          setErrorText('');
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    readNotification,
    isReadNotificationLoading,
  };
};
